import { buildField, getFieldValueIfDirty, isOneFieldOfArrayDirty, updateTabField } from '../../common/utils';
import { SUBCATEGORIES } from '../../common/categories';
import * as actions from './mfaTokensActions';
import { commonActionsReducer } from '../../common/actions';
import {
    DUO_MFA_TOKEN_FIELDS,
    ENTRA_ID_MFA_TOKEN_FIELDS,
    FIDO2_FIELDS,
    HYPR_MFA_TOKEN_FIELDS,
    IS_VISIBLE_FIELD,
    LAST_MODIFIED_FIELD,
    MICROSOFT_MFA_TOKEN_FIELDS,
    OKTA_MFA_TOKEN_FIELDS,
    PING_MFA_TOKEN_FIELDS,
    RSA_MFA_TOKEN_FIELDS
} from '../../common/fields';
import { DEFAULT_VENDOR_TO_ID, SSO_APP_SOURCE_TYPE } from '@silverfort-nodelibs/common/utils/consts';

const {
    DUO_MFA_TOKEN,
    RSA_MFA_TOKEN,
    OKTA_MFA_TOKEN,
    PING_MFA_TOKEN,
    MICROSOFT_MFA_TOKEN,
    HYPR_MFA_TOKEN,
    FIDO2_MFA_TOKEN,
    ENTRA_ID_MFA_TOKEN
} = SUBCATEGORIES;
const { DUO_UPN_FIELD, DUO_API_HOSTNAME, DUO_INTEGRATION_KEY, DUO_SECRET_KEY, DUO_IS_VISIBLE, DUO_LAST_MODIFIED } =
    DUO_MFA_TOKEN_FIELDS;
const { RSA_UPN_FIELD, RSA_REST_ENDPOINT, RSA_API_KEY, RSA_IS_VISIBLE, RSA_LAST_MODIFIED } = RSA_MFA_TOKEN_FIELDS;
const { OKTA_UPN_FIELD, OKTA_URL, OKTA_API_TOKEN, OKTA_IS_VISIBLE, OKTA_LAST_MODIFIED } = OKTA_MFA_TOKEN_FIELDS;
const {
    PING_UPN_FIELD,
    PING_API_KEY,
    PING_TOKEN,
    PING_ORGANIZATION_ALIAS,
    PING_IDP_URL,
    PING_IS_VISIBLE,
    PING_LAST_MODIFIED
} = PING_MFA_TOKEN_FIELDS;
const { AAD_UPN_FIELD, AAD_PUBLIC_KEY, AAD_IS_VISIBLE } = MICROSOFT_MFA_TOKEN_FIELDS;
const { HYPR_APP_ID, HYPR_URL, HYPR_ACCESS_TOKEN, HYPR_IS_VISIBLE, HYPR_LAST_MODIFIED } = HYPR_MFA_TOKEN_FIELDS;
const { FIDO2_RP_ID, FIDO2_ORIGIN, FIDO2_MODE, FIDO2_IS_VISIBLE, FIDO2_LAST_MODIFIED } = FIDO2_FIELDS;
const { ENTRA_ID_MFA_APPS, ENTRA_ID_IS_VISIBLE } = ENTRA_ID_MFA_TOKEN_FIELDS;

export const fieldsReducer = (state, action) => {
    switch (action.type) {
        case actions.UPDATE_DUO_MFA_TOKEN:
            return updateTabField(state, DUO_MFA_TOKEN.ID, action.payload.fieldId, action.payload.value);
        case actions.UPDATE_RSA_MFA_TOKEN:
            return updateTabField(state, RSA_MFA_TOKEN.ID, action.payload.fieldId, action.payload.value);
        case actions.UPDATE_OKTA_MFA_TOKEN:
            return updateTabField(state, OKTA_MFA_TOKEN.ID, action.payload.fieldId, action.payload.value);
        case actions.UPDATE_PING_MFA_TOKEN:
            return updateTabField(state, PING_MFA_TOKEN.ID, action.payload.fieldId, action.payload.value);
        case actions.UPDATE_MICROSOFT_MFA_TOKEN:
            return updateTabField(state, MICROSOFT_MFA_TOKEN.ID, action.payload.fieldId, action.payload.value);
        case actions.UPDATE_HYPR_MFA_TOKEN:
            return updateTabField(state, HYPR_MFA_TOKEN.ID, action.payload.fieldId, action.payload.value);
        case actions.UPDATE_FIDO2_MFA_TOKEN:
            return updateTabField(state, FIDO2_MFA_TOKEN.ID, action.payload.fieldId, action.payload.value);
        case actions.SET_TOKEN_FIELD:
            return setTokenField(state, action.payload.tokenId, action.payload.field, action.payload.value);
        case actions.DELETE_TOKEN:
            return deleteToken(state, action.payload);
        case actions.ADD_MICROSOFT_TENANT:
            return addMicrosoftTenant(state, action.payload);
        case actions.UPDATE_MICROSOFT_TENANT_NAME:
            return updateMicrosoftTenantName(state, action.payload);
        case actions.DELETE_MICROSOFT_TENANT:
            return deleteMicrosoftTenant(state, action.payload);
        case actions.ADD_ENTRA_ID_MFA_TOKEN:
            return addEntraIdMfaToken(state, action.payload);
        case actions.UPDATE_ENTRA_ID_MFA_TOKEN:
            return updateEntraIdMfaToken(state, action.payload);
        case actions.DELETE_ENTRA_ID_MFA_TOKEN:
            return deleteEntraIdToken(state, action.payload);
        default:
            return commonActionsReducer(state, action, initFieldsState);
    }
};

const deleteEntraIdToken = (state, id) => {
    const newState = { ...state };
    const newTokens = newState[ENTRA_ID_MFA_TOKEN.ID].fields[ENTRA_ID_MFA_APPS.ID].value.tokens.filter(
        (t) => t.id !== id
    );
    newState[ENTRA_ID_MFA_TOKEN.ID].fields[ENTRA_ID_MFA_APPS.ID].value.tokens = newTokens;
    return newState;
};
const updateEntraIdMfaToken = (state, { token, id }) => {
    const newState = { ...state };
    const newTokens = newState[ENTRA_ID_MFA_TOKEN.ID].fields[ENTRA_ID_MFA_APPS.ID].value.tokens.map((t) => {
        if (t.id === id) {
            return token;
        }
        return t;
    });
    newState[ENTRA_ID_MFA_TOKEN.ID].fields[ENTRA_ID_MFA_APPS.ID].value.tokens = newTokens;
    return newState;
};

const addEntraIdMfaToken = (state, value) => {
    const newState = { ...state };
    const newTokens = newState[ENTRA_ID_MFA_TOKEN.ID].fields[ENTRA_ID_MFA_APPS.ID].value.tokens.concat(value);
    newState[ENTRA_ID_MFA_TOKEN.ID].fields[ENTRA_ID_MFA_APPS.ID].value.tokens = newTokens;
    return newState;
};

const deleteMicrosoftTenant = (state, tenantId) => {
    const newState = { ...state };
    const newTenants = newState[MICROSOFT_MFA_TOKEN.ID].fields[AAD_PUBLIC_KEY.ID].value.tenants.filter(
        (tenant) => tenant.tenantId !== tenantId
    );
    newState[MICROSOFT_MFA_TOKEN.ID].fields[AAD_PUBLIC_KEY.ID].value.tenants = newTenants;

    return newState;
};

const updateMicrosoftTenantName = (state, { tenantId, name, duplicateRequestHandlingMode }) => {
    const newState = { ...state };
    const newTenants = newState[MICROSOFT_MFA_TOKEN.ID].fields[AAD_PUBLIC_KEY.ID].value.tenants.map((tenant) => {
        if (tenant.tenantId === tenantId) {
            return { ...tenant, name, duplicateRequestHandlingMode, lastModified: Date.now() };
        }
        return tenant;
    });
    newState[MICROSOFT_MFA_TOKEN.ID].fields[AAD_PUBLIC_KEY.ID].value.tenants = newTenants;

    return newState;
};

const addMicrosoftTenant = (state, value) => {
    const newState = { ...state };
    const newTenants = newState[MICROSOFT_MFA_TOKEN.ID].fields[AAD_PUBLIC_KEY.ID].value.tenants.concat(value);
    newState[MICROSOFT_MFA_TOKEN.ID].fields[AAD_PUBLIC_KEY.ID].value.tenants = newTenants;
    return newState;
};

const deleteToken = (state, tokenId) => {
    const newState = { ...state };

    Object.keys(state[tokenId].fields).forEach((field) => {
        if (field === IS_VISIBLE_FIELD.ID) {
            newState[tokenId].fields[field].value = false;
        } else if (field === LAST_MODIFIED_FIELD.ID) {
            newState[tokenId].fields[field].value = Date.now();
        } else {
            newState[tokenId].fields[field].value = newState[tokenId].fields[field]?.options?.[0].value ?? '';
        }
        newState[tokenId].fields[field].isDirty = true;
    });

    return newState;
};

const setTokenField = (state, tokenId, field, value) => {
    return {
        ...state,
        [tokenId]: {
            ...state[tokenId],
            fields: {
                ...state[tokenId].fields,
                [field]: {
                    ...state[tokenId].fields[field],
                    value: value,
                    isDirty: true
                }
            }
        }
    };
};

export const initFieldsState = ({ settings }) => {
    return {
        [DUO_MFA_TOKEN.ID]: {
            id: DUO_MFA_TOKEN.ID,
            name: DUO_MFA_TOKEN.NAME,
            fields: mapDuoFields(settings),
            validators: {}
        },
        [RSA_MFA_TOKEN.ID]: {
            id: RSA_MFA_TOKEN.ID,
            name: RSA_MFA_TOKEN.NAME,
            fields: mapRsaFields(settings),
            validators: {}
        },
        [OKTA_MFA_TOKEN.ID]: {
            id: OKTA_MFA_TOKEN.ID,
            name: OKTA_MFA_TOKEN.NAME,
            fields: mapOktaFields(settings),
            validators: {}
        },
        [PING_MFA_TOKEN.ID]: {
            id: PING_MFA_TOKEN.ID,
            name: PING_MFA_TOKEN.NAME,
            fields: mapPingFields(settings),
            validators: {}
        },
        [MICROSOFT_MFA_TOKEN.ID]: {
            id: MICROSOFT_MFA_TOKEN.ID,
            name: MICROSOFT_MFA_TOKEN.NAME,
            fields: mapAADFields(settings),
            validators: {}
        },
        [ENTRA_ID_MFA_TOKEN.ID]: {
            id: ENTRA_ID_MFA_TOKEN.ID,
            name: ENTRA_ID_MFA_TOKEN.NAME,
            fields: mapEntraIdFields(settings),
            validators: {}
        },
        [HYPR_MFA_TOKEN.ID]: {
            id: HYPR_MFA_TOKEN.ID,
            name: HYPR_MFA_TOKEN.NAME,
            fields: mapHyprFields(settings),
            validators: {},
            error: null
        },
        [FIDO2_MFA_TOKEN.ID]: {
            id: FIDO2_MFA_TOKEN.ID,
            name: FIDO2_MFA_TOKEN.NAME,
            fields: mapFido2Fields(settings),
            validators: {}
        }
    };
};

export const mapDuoFields = (settings) => {
    return {
        [DUO_UPN_FIELD.ID]: {
            ...buildField(DUO_UPN_FIELD, settings.DuoUPNField),
            options: settings.DuoUPNFieldOptions
        },
        [DUO_API_HOSTNAME.ID]: buildField(DUO_API_HOSTNAME, settings.DuoAPIHostname, { notWhitespace: true }),
        [DUO_INTEGRATION_KEY.ID]: buildField(DUO_INTEGRATION_KEY, settings.DuoIntegrationKey, {
            notWhitespace: true
        }),
        [DUO_SECRET_KEY.ID]: buildField(DUO_SECRET_KEY, settings.DuoSecretKey, { notWhitespace: true }),
        [DUO_IS_VISIBLE.ID]: buildField(DUO_IS_VISIBLE, !!settings.DuoAPIHostname && !!settings.DuoIntegrationKey),
        [DUO_LAST_MODIFIED.ID]: buildField(DUO_LAST_MODIFIED, settings.DuoLastModified)
    };
};

export const mapRsaFields = (settings) => {
    return {
        [RSA_UPN_FIELD.ID]: {
            ...buildField(RSA_UPN_FIELD, settings.RSAUPNField),
            options: settings.RSAUPNFieldOptions
        },
        [RSA_REST_ENDPOINT.ID]: buildField(RSA_REST_ENDPOINT, settings.RSARestEndpoint, {
            notWhitespace: true
        }),
        [RSA_API_KEY.ID]: buildField(RSA_API_KEY, settings.RSAApiKey, { notWhitespace: true }),
        [RSA_IS_VISIBLE.ID]: buildField(RSA_IS_VISIBLE, !!settings.RSARestEndpoint && !!settings.RSAApiKey),
        [RSA_LAST_MODIFIED.ID]: buildField(RSA_LAST_MODIFIED, settings.RSALastModified)
    };
};

export const mapOktaFields = (settings) => {
    return {
        [OKTA_UPN_FIELD.ID]: {
            ...buildField(OKTA_UPN_FIELD, settings.OktaUPNField),
            options: settings.OktaUPNFieldOptions
        },
        [OKTA_URL.ID]: buildField(OKTA_URL, settings.OktaUrl, {
            notWhitespace: true
        }),
        [OKTA_API_TOKEN.ID]: buildField(OKTA_API_TOKEN, settings.OktaAPIToken, { notWhitespace: true }),
        [OKTA_IS_VISIBLE.ID]: buildField(OKTA_IS_VISIBLE, !!settings.OktaUrl && !!settings.OktaAPIToken),
        [OKTA_LAST_MODIFIED.ID]: buildField(OKTA_LAST_MODIFIED, settings.OktaLastModified)
    };
};

export const mapPingFields = (settings) => {
    return {
        [PING_UPN_FIELD.ID]: {
            ...buildField(PING_UPN_FIELD, settings.PingUPNField),
            options: settings.PingUPNFieldOptions
        },
        [PING_API_KEY.ID]: buildField(PING_API_KEY, settings.PingAPIKey, { notWhitespace: true }),
        [PING_TOKEN.ID]: buildField(PING_TOKEN, settings.PingToken, { notWhitespace: true }),
        [PING_ORGANIZATION_ALIAS.ID]: buildField(PING_ORGANIZATION_ALIAS, settings.PingOrgAlias, {
            notWhitespace: true
        }),
        [PING_IDP_URL.ID]: buildField(PING_IDP_URL, settings.PingURL, { httpsUrl: true }),
        [PING_IS_VISIBLE.ID]: buildField(
            PING_IS_VISIBLE,
            !!settings.PingAPIKey && !!settings.PingToken && !!settings.PingOrgAlias && !!settings.PingURL
        ),
        [PING_LAST_MODIFIED.ID]: buildField(PING_LAST_MODIFIED, settings.PingLastModified)
    };
};

export const mapAADFields = (settings) => {
    return {
        [AAD_UPN_FIELD.ID]: {
            ...buildField(AAD_UPN_FIELD, settings.AADUPNField),
            options: settings.AzureADUPNFieldOptions
        },
        [AAD_PUBLIC_KEY.ID]: buildField(AAD_PUBLIC_KEY, {
            tenants: settings.AADTenants
        }),
        [AAD_IS_VISIBLE.ID]: buildField(AAD_IS_VISIBLE, settings.AADTenants.length > 0)
    };
};
export const mapEntraIdFields = (settings) => {
    const entraSSOTokens = Object.values(settings.SSOApplications)
        .filter((app) => app.source === SSO_APP_SOURCE_TYPE.MFA_TOKENS)
        .filter((app) => app.vendorId === DEFAULT_VENDOR_TO_ID.AZURE);

    return {
        [ENTRA_ID_IS_VISIBLE.ID]: buildField(ENTRA_ID_IS_VISIBLE, entraSSOTokens.length > 0),
        [ENTRA_ID_MFA_APPS.ID]: buildField(ENTRA_ID_MFA_APPS, { tokens: entraSSOTokens })
    };
};

export const mapHyprFields = (settings) => {
    return {
        [HYPR_APP_ID.ID]: buildField(HYPR_APP_ID, settings.HyprAppId, { notWhitespace: true }),
        [HYPR_URL.ID]: buildField(HYPR_URL, settings.HyprUrl, { notWhitespace: true }),
        [HYPR_ACCESS_TOKEN.ID]: buildField(HYPR_ACCESS_TOKEN, settings.HyprAccessToken, { notWhitespace: true }),
        [HYPR_IS_VISIBLE.ID]: buildField(
            HYPR_IS_VISIBLE,
            !!settings.HyprAppId && !!settings.HyprUrl && !!settings.HyprAccessToken
        ),
        [HYPR_LAST_MODIFIED.ID]: buildField(HYPR_LAST_MODIFIED, settings.HyprLastModified)
    };
};

export const mapFido2Fields = (settings) => {
    return {
        [FIDO2_MODE.ID]: buildField(FIDO2_MODE, settings.Fido2Mode, { customValidator: () => null }),
        [FIDO2_RP_ID.ID]: buildField(FIDO2_RP_ID, settings.WebAuthnRpId, { notWhitespace: true }),
        [FIDO2_ORIGIN.ID]: buildField(FIDO2_ORIGIN, settings.WebAuthnOrigin, { notWhitespace: true }),
        [FIDO2_IS_VISIBLE.ID]: buildField(
            FIDO2_IS_VISIBLE,
            !!settings.Fido2Mode && !!settings.WebAuthnRpId && !!settings.WebAuthnOrigin
        ),
        [FIDO2_LAST_MODIFIED.ID]: buildField(FIDO2_LAST_MODIFIED, settings.Fido2LastModified)
    };
};

const parseOktaUrl = (oktaUrl) => {
    if (!oktaUrl) {
        return oktaUrl;
    }
    let parsedOktaUrl = oktaUrl;
    if (parsedOktaUrl.startsWith('https://')) {
        parsedOktaUrl = parsedOktaUrl.slice('https://'.length);
    }
    while (parsedOktaUrl.endsWith('/')) {
        parsedOktaUrl = parsedOktaUrl.slice(0, -1);
    }
    return parsedOktaUrl;
};

export const mapToSettings = (saveAll, selectedTab, fields) => {
    const newSettings = {};

    if (saveAll || selectedTab === ENTRA_ID_MFA_TOKEN.ID) {
        const entraIdFields = fields[ENTRA_ID_MFA_TOKEN.ID].fields;
        newSettings.EntraIdTokens = entraIdFields[ENTRA_ID_MFA_APPS.ID].value.tokens;
    }

    if (saveAll || selectedTab === DUO_MFA_TOKEN.ID) {
        const duoFields = fields[DUO_MFA_TOKEN.ID].fields;
        newSettings.DuoUPNField = getFieldValueIfDirty(duoFields[DUO_UPN_FIELD.ID]);
        newSettings.DuoAPIHostname = getFieldValueIfDirty(duoFields[DUO_API_HOSTNAME.ID]);
        newSettings.DuoIntegrationKey = getFieldValueIfDirty(duoFields[DUO_INTEGRATION_KEY.ID]);
        newSettings.DuoSecretKey = getFieldValueIfDirty(duoFields[DUO_SECRET_KEY.ID]);

        if (isOneFieldOfArrayDirty(Object.values(duoFields))) {
            newSettings.DuoLastModified = Date.now();
        }
    }
    if (saveAll || selectedTab === RSA_MFA_TOKEN.ID) {
        const rsaFields = fields[RSA_MFA_TOKEN.ID].fields;
        newSettings.RSAUPNField = getFieldValueIfDirty(rsaFields[RSA_UPN_FIELD.ID]);
        newSettings.RSARestEndpoint = getFieldValueIfDirty(rsaFields[RSA_REST_ENDPOINT.ID]);
        newSettings.RSAApiKey = getFieldValueIfDirty(rsaFields[RSA_API_KEY.ID]);

        if (isOneFieldOfArrayDirty(Object.values(rsaFields))) {
            newSettings.RSALastModified = Date.now();
        }
    }
    if (saveAll || selectedTab === OKTA_MFA_TOKEN.ID) {
        const oktaFields = fields[OKTA_MFA_TOKEN.ID].fields;
        newSettings.OktaUPNField = getFieldValueIfDirty(oktaFields[OKTA_UPN_FIELD.ID]);

        newSettings.OktaUrl = parseOktaUrl(getFieldValueIfDirty(oktaFields[OKTA_URL.ID]));
        newSettings.OktaAPIToken = getFieldValueIfDirty(oktaFields[OKTA_API_TOKEN.ID]);

        if (isOneFieldOfArrayDirty(Object.values(oktaFields))) {
            newSettings.OktaLastModified = Date.now();
        }
    }
    if (saveAll || selectedTab === PING_MFA_TOKEN.ID) {
        const pingFields = fields[PING_MFA_TOKEN.ID].fields;
        newSettings.PingUPNField = getFieldValueIfDirty(pingFields[PING_UPN_FIELD.ID]);
        newSettings.PingAPIKey = getFieldValueIfDirty(pingFields[PING_API_KEY.ID]);
        newSettings.PingToken = getFieldValueIfDirty(pingFields[PING_TOKEN.ID]);
        newSettings.PingOrgAlias = getFieldValueIfDirty(pingFields[PING_ORGANIZATION_ALIAS.ID]);
        newSettings.PingURL = getFieldValueIfDirty(pingFields[PING_IDP_URL.ID]);

        if (isOneFieldOfArrayDirty(Object.values(pingFields))) {
            newSettings.PingLastModified = Date.now();
        }
    }
    if (saveAll || selectedTab === MICROSOFT_MFA_TOKEN.ID) {
        const microsoftFields = fields[MICROSOFT_MFA_TOKEN.ID].fields;
        newSettings.AADUPNField = microsoftFields[AAD_UPN_FIELD.ID].value;
        newSettings.AADTenants = microsoftFields[AAD_PUBLIC_KEY.ID].value.tenants;
    }
    if (saveAll || selectedTab === HYPR_MFA_TOKEN.ID) {
        const hyprFields = fields[HYPR_MFA_TOKEN.ID].fields;
        newSettings.HyprAppId = getFieldValueIfDirty(hyprFields[HYPR_APP_ID.ID]);
        newSettings.HyprUrl = getFieldValueIfDirty(hyprFields[HYPR_URL.ID]);
        newSettings.HyprAccessToken = getFieldValueIfDirty(hyprFields[HYPR_ACCESS_TOKEN.ID]);

        if (isOneFieldOfArrayDirty(Object.values(hyprFields))) {
            newSettings.HyprLastModified = Date.now();
        }
    }
    if (saveAll || selectedTab === FIDO2_MFA_TOKEN.ID) {
        const fido2Fields = fields[FIDO2_MFA_TOKEN.ID].fields;
        newSettings.Fido2Mode = getFieldValueIfDirty(fido2Fields[FIDO2_MODE.ID]);
        newSettings.WebAuthnRpId = getFieldValueIfDirty(fido2Fields[FIDO2_RP_ID.ID]);
        newSettings.WebAuthnOrigin = getFieldValueIfDirty(fido2Fields[FIDO2_ORIGIN.ID]);

        if (isOneFieldOfArrayDirty(Object.values(fido2Fields))) {
            newSettings.Fido2LastModified = Date.now();
        }
    }
    return newSettings;
};
